import React, { useState } from 'react'
import { Form, Button } from 'react-bootstrap'

const FlightNumber = (props) => {
 const [flightNumber,setFlightNumber] = useState('')
 const [showNumberForm, setShowNumberForm] = useState(true)
 const handleFlightNumberSubmit = (e) => {
    e.preventDefault();
   
    if (!flightNumber) {
      return 
      ; // If any field is empty, prevent form submission
    }
   
   props.actionProvider.handleFlightNumberSubmit(flightNumber);
   setShowNumberForm(false)
  };

  return (
    <div>
        {showNumberForm && (
            <Form style={{backgroundColor: '#DFE1E1'}} className='p-3'>
            <Form.Control 
                   type="text" className='mb-2'
                   placeholder="Flight Number"
                   name="number"
                   value={flightNumber}
                   onChange={(e) => setFlightNumber(e.target.value)}
                 />
                 <Button style={{backgroundColor:'#008080'}} onClick={handleFlightNumberSubmit}>Submit</Button>
           </Form>
        )}
    </div>
    
  )
}

export default FlightNumber
